import React from 'react';
import { cx } from '../cx';
import { SignalDot, type SignalDotColor } from './SignalDot';

// 신호등 범례 줄 — 점 색의 이름을 한 줄로 알려 준다 (D-09 §15.53, D-07 §3.2 #20 예외로 승인된 신규 컴포넌트).
// 점은 SignalDot(D-08 §6.15) 그대로 쓰고, 이 컴포넌트는 '제목 · 순서 설명 · 색 이름 목록 · 안내 문구' 배치만 맡는다.
// 점 단독으로 의미를 전하지 않도록 색마다 이름(label)을 곁들인다. 숨김·표시는 호출부가 정한다(예: 신호등 켠 때만).
export interface SignalLegendItem {
  color: SignalDotColor;
  /** 색 이름 — 상태 이름(예: '정상', '조치 필요') */
  label: string;
}

export interface SignalLegendProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** 맨 앞 제목(예: '신호등') */
  title?: React.ReactNode;
  /** 제목 옆 보조 설명(예: '반장·발주·작업 순') */
  caption?: React.ReactNode;
  /** 점 + 이름 목록 */
  items: SignalLegendItem[];
  /** 맨 뒤 안내 문구(오른쪽 끝) */
  hint?: React.ReactNode;
}

export function SignalLegend({ title, caption, items, hint, className = '', ...props }: SignalLegendProps) {
  return (
    <div className={cx('signal-legend', className)} {...props}>
      {title && <b className="signal-legend-title">{title}</b>}
      {caption && <span className="signal-legend-caption">{caption}</span>}
      <span className="signal-legend-items">
        {items.map(it => (
          <span key={it.label} className="signal-legend-item">
            <SignalDot color={it.color} />
            {it.label}
          </span>
        ))}
      </span>
      {hint && <span className="signal-legend-hint">{hint}</span>}
    </div>
  );
}
